export interface LegacyHolidayRow {
  id: string
  date: string
  day: string
  name: string
  isHoliday: boolean
  memo: string
}

export const legacyHolidayYears = ['2025', '2026', '2027']

export const legacyHolidayRows: LegacyHolidayRow[] = [
  { id: 'mock-holiday-01', date: '2026-01-01', day: '목', name: 'Mock 신정', isHoliday: true, memo: '비식별 Mock 공휴일' },
  { id: 'mock-holiday-02', date: '2026-03-01', day: '일', name: 'Mock 기념일', isHoliday: true, memo: '비식별 Mock 공휴일' },
  { id: 'mock-holiday-03', date: '2026-05-05', day: '화', name: 'Mock 어린이날', isHoliday: true, memo: '비식별 Mock 공휴일' },
]
